const configuredBase = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5001").replace(/\/+$/, "");

export const API_BASE_URL = configuredBase.endsWith("/api")
  ? configuredBase
  : `${configuredBase}/api`;

export function buildApiUrl(pathname = "/") {
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${API_BASE_URL}${path}`;
}
